// Lightweight GA4 / analytics helper — safely no-ops if gtag isn't loaded
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (e) {
    // ignore
  }
};

export const CALENDLY_LINK = 'https://calendly.com/hitesh-ejqa/ppc-discussion';

export const openCalendly = (source = 'unknown') => {
  trackEvent('book_call_click', {
    event_category: 'conversion',
    event_label: source,
    cta_source: source,
  });
  trackEvent('generate_lead', { value: 1, currency: 'USD', method: source });
  window.open(CALENDLY_LINK, '_blank', 'noopener,noreferrer');
};
